import React, { useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import ZoomPopup from "../ZoomPopup"
import colors from "../../../styles/colors"

const LayoutGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  margin-left: 0;
`

const ImageContainer = styled.div`
  max-width: ${(props) => (props.$half ? "calc(50% - 11px)" : "100%")};
  position: relative;
  padding-bottom: ${(props) =>
    props.$half ? "calc(50% - 11px)" : props.$landscape ? "65%" : "100%"};
  width: 100%;
`

const StyledImage = styled(GatsbyImage)`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  cursor: zoom-in;
`

const StyledVideo = styled.video`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  cursor: zoom-in;
  object-fit: cover;
`

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  z-index: 888;
  top: 0;
  left: 0;
  position: fixed;
  background: ${colors.white};
  opacity: 0.5;
  display: ${(props) => (props.$isZoomOpen ? "block" : "none")};
`

const ProductImageLayout = ({ sliderImages, mainImage, productName }) => {
  const [isZoomOpen, setIsZoomOpen] = useState(false)
  const [zoomIndex, setZoomIndex] = useState(0)

  const toggleZoom = (index) => {
    setIsZoomOpen(true)
    setZoomIndex(index)
  }

  let images = [...sliderImages]

  images.splice(1, 0, mainImage)

  let shownImages = [];

  return (
    <>
      <LayoutGrid>
        {images.map((image, index) => {
          if (!image) {
            return null;
          }

          // hack to prevent duplicates
          if (shownImages.includes(image.src)) {
            return null;
          }

          shownImages.push(image.src);
          
          return (
            <ImageContainer key={index} onClick={() => toggleZoom(index.toString())}>
              {image.altText && !image.altText.includes("cord-") ? (
                <StyledVideo
                  src={image.altText}
                  loop
                  muted
                  autoPlay
                  playsInline
                  preload="metadata"
                  aria-label="video"
                />
              ) : (
                <StyledImage
                  image={image.gatsbyImageData}
                  alt={productName}
                  loading={index === 0 ? "eager" : "lazy"}
                />
              )}
            </ImageContainer>
          )
        })}
      </LayoutGrid>
      <Overlay $isZoomOpen={isZoomOpen} />
      {isZoomOpen && (
        <ZoomPopup
          sliderImages={images}
          closePopupFunction={() => setIsZoomOpen(false)}
          initialSlide={zoomIndex}
        />
      )}
    </>
  )
}

export default ProductImageLayout

